import React from "react";

const MiscellaneousSettings = () => {
    return <div>MiscellaneousSettings</div>
}

export default MiscellaneousSettings;